import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/eu-readiness")({
  head: () => buildRouteHead("/eu-readiness", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/eu-readiness", replace: true });
  },
});
